import { render, staticRenderFns } from "./member_points.vue?vue&type=template&id=1e8043a1&"
import script from "./member_points.vue?vue&type=script&lang=ts&"
export * from "./member_points.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports